<!--班组考核-->
<template>
	<div style="height: 100%;">
        <datePicker ref="datepicker" :initDate='bgDate' @selectDatetime="selectBgDate" type="dayTime"></datePicker>
		<div style="height: 100%;">
			<div class="searchContainer">
				<dateButton @dateClick="showpicker()" :date='bgDate.formatByTime()' name='开始时间：'></dateButton>
				<el-button @click="getDataList" >查询</el-button>
				<el-button @click="exportReport" >导出</el-button>
			</div>
			<!-- <el-table :data="dataList" :header-cell-style="{'text-align':'center','background': '#F1F4F7'}" :cell-style="{'text-align':'center'}" border>
				<el-table-column fixed type="index" width="50"></el-table-column>
				<el-table-column label="班组名" prop="groupName" width="160"></el-table-column>
				<el-table-column label="班组时间" prop="workTime"></el-table-column>
				<el-table-column label="班组设备" prop="deviceNames"></el-table-column>
				<el-table-column label="电量（kWh）" prop="power" width="160"></el-table-column>
				<el-table-column label="创建时间" width="220">
					<template slot-scope="scope">
						<span>{{ new Date(scope.row.createTime).format('yyyy年MM月dd日 hh时mm分') }}</span>
					</template>
				</el-table-column>
			</el-table>
			<div style="width: 98%;display: flex;align-items: center;justify-content: flex-end;">
				<el-pagination
				@current-change='jumpToPage'
				:page-size="totalSize"
				layout="total, prev, pager, next, jumper"
				:total="totalSize">
				</el-pagination>
			</div> -->
			<div class="custom-scrollbar infoListContainer">
				<div>
					<infoList ref="meterManagerList"
					:columns="columns" 
					:totalSize="totalSize"
					:dataList="dataList" 
					:showSelection="false" 
					@pageSizeChange="pageSizeChange" 
					@jumpToPage="jumpToPage">
					</infoList>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    import datePicker from '@/components/module/universal/datePicker.vue'
	import dateButton from '@/components/module/universal/dateButton.vue'
	import infoList from '@/components/module/universal/infoList.vue'
	export default {
		components: {
			datePicker,
			infoList,
            dateButton
		},
		props: {},
		data() {
			return {
				pageIndex: 0,
				pageSize: 20,
				totalSize: 0,
				dataList: [],
				filterTime: false,
                searchChange: false,
                columns:[
                    {
                        name: '班组名称',
                        key: 'groupName',
                    },
                    {
                        name: '班组时间',
                        key: 'workTime',
                    },
                    {
                        name: '班组设备',
                        key: 'deviceNames',
                    },
                    {
                        name: '电量（kWh）',
                        key: 'power',
				    },
                ],
                bgDate: new Date(),
			}
		},
		created() {},
		mounted() {
			this.getDataList()
		},
		destroyed() {},
		computed: {
			nowUnit() {
				return this.$store.unitStore.state.nowUnit
			},
		},
		watch: {
            bgDate(nv, ov) {
                this.$refs.datepicker.hide()
                this.getDataList()
			},
			nowUnit(nv, ov){
				this.getDataList()
			},
			filterTime(nv, ov){
				this.searchChange = true
			},
		},
		methods: {
            showpicker() {
				this.$refs.datepicker.show()
			},
            selectBgDate(date) {
                this.bgDate = date
                this.filterTime = true
			},
			// 获取列表信息
			getDataList() {/* 
				if(isempty(this.nowUnit)){
					return
				} */
				if(this.searchChange){
					this.pageIndex = 1
					this.$refs.meterManagerList.pageIndex = 1
					this.searchChange = false
				}
                var beginTime = this.filterTime ? this.bgDate.getTime() : new Date().getTime()
                this.$dialogMethod.showLoading('正在加载');
				this.$api.teamAssessmentApi.countTeamGroupElectricity(beginTime, this.pageIndex, this.pageSize, respon => {
                    this.dataList = respon.dataList
                    for(var i=0;i<this.dataList.length;i++){
                        if(!isempty(this.dataList[i].deviceNames)){
                            this.dataList[i].deviceNames=this.dataList[i].deviceNames.join(' , ')
                        }
                    }
					this.totalSize = respon.total
                    //this.$refs.meterManagerList.totalSize = respon.total
                    this.$dialogMethod.closeLoading();
				})
			},
			// 导出报表
			exportReport() {
				var title = this.bgDate.getFullYear() + '年' + (this.bgDate.getMonth() + 1) + '月' + this.bgDate.getDate() + '日' + this.bgDate.getHours() + '时' + '班组考核表'
				this.$api.teamAssessmentApi.exportTeamGroupElectricity(this.bgDate.getTime(), respon => {
					saveAs(DWSystemSetting.downloadUrl + '/' + respon, title + ".xls")
				})
			},
			// 切换每页显示条数
			pageSizeChange(pageSize) {
				this.pageIndex = 1
				this.pageSize = pageSize
				this.getDataList()
			},
			// 切换页码
			jumpToPage(pageIndex) {
				log(pageIndex)
				this.pageIndex = pageIndex
				this.getDataList()
			},
		}
	}
</script>

<style scoped>
	.searchContainer{
		padding: 10px 20px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	
	.searchContainer>div{
		display: inline-flex;
		flex-wrap: wrap;
		align-items: center;
		flex-grow: 0;
	}
	
	.searchContainer label{
		margin-right: 6px;
	}
	
	.searchContainer input{
		border-color: #DCDFE6;
		min-width: 130px;
		height: 36px;
		box-sizing: border-box;
		margin-right: 10px;
	}
	
	.searchContainer>button{
		height: 32px;
		background-color: #409EFF;
		color: #FFFFFF;
		padding: 0 18px;
		margin-left: 10px;
		border-radius: 4px;
		flex-shrink: 0;
		cursor: pointer;
	}
	
	.infoListContainer{
		padding: 0 0 20px 20px;
		height: calc(100% - 76px);
	}
	
	.infoListContainer::-webkit-scrollbar{
		width: 10px;
		height: 10px;
	}
	
	.infoListContainer::-webkit-scrollbar-track {
		box-shadow: none;
		background-color: #FFFFFF;
	}

	.infoListContainer:hover::-webkit-scrollbar-track {
		box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
		background-color: #F0F0F0;
	}
	
	.infoListContainer::-webkit-scrollbar-thumb {
		background-color: #FFFFFF;
	}
	
	.infoListContainer:hover::-webkit-scrollbar-thumb {
		background-color: #CACACA;
	}
	
	.infoListContainer>div{
		width: calc(100% - 10px);
	}
	
	
	@media screen and (max-width: 1600px) {
		.searchContainer label{
			display: block;
			margin-right: 0;
		}
		
		.infoListContainer{
			height: calc(100% - 96px);
		}
	}
</style>
